const roles = [

    // Defenders
    {
        // label: "Außenverteidiger (Verteidigen)",
        id: "r1",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 0,
                marking: 2,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 1,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 2,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 0,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 2,
                bravery: 0,
                composure: 1,
                offTheBall: 0,
                positioning: 2,
                teamwork: 1,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 1,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 1,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Außenverteidiger (Unterstützen)",
        id: "r2",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 0,
                marking: 2,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 1,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 2,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 2,
                bravery: 0,
                composure: 1,
                offTheBall: 0,
                positioning: 2,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 1,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 1,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Außenverteidiger (Angreifen)",
        id: "r3",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 1,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 2,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 2,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 0,
                composure: 1,
                offTheBall: 1,
                positioning: 2,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 1,
                stamina: 2,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 2,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Ballspielender Verteidiger (Verteidigen)",
        id: "r4",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 2,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 2,
                passing: 2,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 1,
                anticipation: 1,
                workRate: 0,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 1,
                composure: 2,
                offTheBall: 0,
                positioning: 2,
                teamwork: 0,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 2,
                pace: 1,
                jumpingReach: 2,
            }
        }
    },
    {
        // label: "Ballspielender Verteidiger (Vorstopper)",
        id: "r5",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 1,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 2,
                passing: 2,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 2,
                anticipation: 1,
                workRate: 0,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 2,
                composure: 2,
                offTheBall: 0,
                positioning: 2,
                teamwork: 0,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 2,
                pace: 0,
                jumpingReach: 2,
            }
        }
    },

    {
        // label: "Ballspielender Verteidiger (Rückendeckend)",
        id: "r6",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 2,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 1,
                passing: 2,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 0,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 2,
                bravery: 1,
                composure: 2,
                offTheBall: 0,
                positioning: 2,
                teamwork: 0,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 1,
                pace: 2,
                jumpingReach: 1,
            }
        }
    },
    {
        // label: "Flügelverteidiger (Verteidigen)",
        id: "r7",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 2,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 1,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 2,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 0,
                composure: 0,
                offTheBall: 1,
                positioning: 2,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 2,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 1,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Flügelverteidiger (Unterstützend)",
        id: "r8",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 2,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 2,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 2,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 0,
                composure: 0,
                offTheBall: 2,
                positioning: 1,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 2,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 1,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Flügelverteidiger (Angreifend)",
        id: "r9",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 1,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 2,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 2,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 2,
                decisions: 1,
                flair: 1,
                leadership: 0,
                concentration: 1,
                bravery: 0,
                composure: 0,
                offTheBall: 2,
                positioning: 1,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 2,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 2,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Innenverteidiger (Verteidigen)",
        id: "r10",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 0,
                marking: 2,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 2,
                passing: 0,
                tackling: 2,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 1,
                anticipation: 1,
                workRate: 0,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 1,
                composure: 1,
                offTheBall: 0,
                positioning: 2,
                teamwork: 0,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 2,
                pace: 1,
                jumpingReach: 2,
            }
        }
    },
    {
        // label: "Innenverteidiger (Vorstopper)",
        id: "r11",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 0,
                marking: 1,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 2,
                passing: 0,
                tackling: 2,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 2,
                anticipation: 1,
                workRate: 0,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 2,
                composure: 1,
                offTheBall: 0,
                positioning: 2,
                teamwork: 0,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 2,
                pace: 0,
                jumpingReach: 2,
            }
        }
    },
    {
        // label: "Innenverteidiger (Rückendecken)",
        id: "r12",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 0,
                marking: 2,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 1,
                passing: 0,
                tackling: 2,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 0,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 2,
                bravery: 1,
                composure: 1,
                offTheBall: 0,
                positioning: 2,
                teamwork: 0,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 1,
                pace: 2,
                jumpingReach: 1,
            }
        }
    },
    {
        // label: "Inverser Außenverteidiger (Verteidigen)",
        id: "r13",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 2,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 2,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 0,
                composure: 0,
                offTheBall: 1,
                positioning: 2,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 1,
                stamina: 1,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Inverser Außenverteidiger (Unterstützen)",
        id: "r14",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 2,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 2,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 1,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 1,
                stamina: 2,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Inverser Außenverteidiger (Angreifen)",
        id: "r15",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 2,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 2,
                technique: 2,
                longThrows: 0,
                longShots: 1,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 2,
                decisions: 2,
                flair: 1,
                leadership: 0,
                concentration: 1,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 1,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 2,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 1,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Kompletter Flügelverteidiger (Unterstützend)",
        id: "r16",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 2,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 1,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 2,
                decisions: 2,
                flair: 1,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 0,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 2,
                balance: 1,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 2,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Kompletter Flügelverteidiger (Angreifen)",
        id: "r17",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 2,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 1,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 2,
                decisions: 2,
                flair: 2,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 0,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 2,
                balance: 1,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 2,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Kompromissloser Außenverteidiger (Verteidigen)",
        id: "r18",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 0,
                marking: 2,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 1,
                passing: 0,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 1,
                anticipation: 2,
                workRate: 0,
                decisions: 0,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 1,
                composure: 0,
                offTheBall: 0,
                positioning: 2,
                teamwork: 1,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 2,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Kompromissloser Innenverteidiger (Verteidigen)",
        id: "r19",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 0,
                marking: 2,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 2,
                passing: 0,
                tackling: 2,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 1,
                anticipation: 1,
                workRate: 0,
                decisions: 0,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 1,
                composure: 0,
                offTheBall: 0,
                positioning: 2,
                teamwork: 0,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 2,
                pace: 1,
                jumpingReach: 2,
            }
        }
    },
    {
        // label: "Kompromissloser Innenverteidiger (Vorstopper)",
        id: "r20",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 0,
                marking: 1,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 2,
                passing: 0,
                tackling: 2,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 2,
                anticipation: 1,
                workRate: 0,
                decisions: 0,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 2,
                composure: 0,
                offTheBall: 0,
                positioning: 2,
                teamwork: 0,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 2,
                pace: 0,
                jumpingReach: 2,
            }
        }
    },
    {
        // label: "Kompromissloser Innenverteidiger (Rückendeckung)",
        id: "r21",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 0,
                marking: 2,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 1,
                passing: 0,
                tackling: 2,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 0,
                decisions: 0,
                flair: 0,
                leadership: 0,
                concentration: 2,
                bravery: 1,
                composure: 0,
                offTheBall: 0,
                positioning: 2,
                teamwork: 0,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 1,
                pace: 2,
                jumpingReach: 1,
            }
        }
    },
    {
        // label: "Libero (Unterstützend)",
        id: "r22",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 2,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 1,
                passing: 2,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 0,
                decisions: 2,
                flair: 1,
                leadership: 0,
                concentration: 2,
                bravery: 1,
                composure: 2,
                offTheBall: 0,
                positioning: 2,
                teamwork: 2,
                vision: 2,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 1,
                balance: 1,
                agility: 1,
                naturalFitness: 0,
                strength: 1,
                pace: 2,
                jumpingReach: 1,
            }
        }
    },
    {
        // label: "Libero (Angreifen)",
        id: "r23",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 2,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 1,
                passing: 2,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 1,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 0,
                decisions: 2,
                flair: 2,
                leadership: 0,
                concentration: 2,
                bravery: 1,
                composure: 2,
                offTheBall: 0,
                positioning: 2,
                teamwork: 2,
                vision: 2,
                determination: 0,
            },
            physical: {
                acceleration: 1,
                stamina: 1,
                balance: 1,
                agility: 1,
                naturalFitness: 0,
                strength: 1,
                pace: 2,
                jumpingReach: 1,
            }
        }
    },

    // Midfield:
    {
        // label: "Abräumer (Verteidigen)",
        id: "r24",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 0,
                marking: 2,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 0,
                tackling: 2,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 0,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 2,
                bravery: 0,
                composure: 1,
                offTheBall: 0,
                positioning: 2,
                teamwork: 1,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 1,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Äuserer Mittelfeldspieler (Verteidigen)",
        id: "r25",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 1,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 1,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 2,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 2,
                bravery: 0,
                composure: 1,
                offTheBall: 0,
                positioning: 2,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 1,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Äuserer Mittelfeldspieler (Unterstützen)",
        id: "r26",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 1,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 2,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 0,
                composure: 1,
                offTheBall: 1,
                positioning: 1,
                teamwork: 2,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 2,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Äuserer Mittelfeldspieler (Angreifen)",
        id: "r27",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 2,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 1,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 2,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 1,
                offTheBall: 1,
                positioning: 0,
                teamwork: 2,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 2,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Äußerer Spielmacher (Unterstützen)",
        id: "r28",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 0,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 0,
                workRate: 0,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 2,
                offTheBall: 1,
                positioning: 0,
                teamwork: 2,
                vision: 2,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Äußerer Spielmacher (Angreifen)",
        id: "r29",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 0,
                decisions: 2,
                flair: 1,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 2,
                offTheBall: 2,
                positioning: 0,
                teamwork: 2,
                vision: 2,
                determination: 0,
            },
            physical: {
                acceleration: 1,
                stamina: 0,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Äußerer Zielspieler (Unterstützen)",
        id: "r30",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 1,
                freeKickTaking: 0,
                heading: 2,
                passing: 0,
                tackling: 0,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 1,
                decisions: 0,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 2,
                composure: 0,
                offTheBall: 1,
                positioning: 0,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 1,
                balance: 1,
                agility: 0,
                naturalFitness: 0,
                strength: 2,
                pace: 0,
                jumpingReach: 2,
            }
        }
    },
    {
        // label: "Äußerer Zielspieler (Angreifen)",
        id: "r31",
        attributes: {
            technical: {
                finishing: 1,
                firstTouch: 1,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 1,
                freeKickTaking: 0,
                heading: 2,
                passing: 0,
                tackling: 0,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 1,
                decisions: 0,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 2,
                composure: 0,
                offTheBall: 2,
                positioning: 0,
                teamwork: 1,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 1,
                balance: 1,
                agility: 0,
                naturalFitness: 0,
                strength: 2,
                pace: 0,
                jumpingReach: 2,
            }
        }
    },
    {
        // label: "Ballerobernder Mittelfeldspieler (Verteidigen)",
        id: "r32",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 0,
                marking: 1,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 0,
                tackling: 2,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 2,
                anticipation: 2,
                workRate: 2,
                decisions: 0,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 2,
                composure: 0,
                offTheBall: 0,
                positioning: 1,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 1,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 1,
                pace: 1,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Ballerobernder Mittelfeldspieler (Unterstützen)",
        id: "r33",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 0,
                marking: 1,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 2,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 2,
                anticipation: 2,
                workRate: 2,
                decisions: 0,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 2,
                composure: 0,
                offTheBall: 0,
                positioning: 0,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 1,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 1,
                pace: 1,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Box-to-Box Mittelfeldspieler (Unterstützen)",
        id: "r34",
        attributes: {
            technical: {
                finishing: 1,
                firstTouch: 1,
                marking: 0,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 1,
            },
            mental: {
                aggression: 1,
                anticipation: 1,
                workRate: 2,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 1,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 1,
                stamina: 2,
                balance: 1,
                agility: 0,
                naturalFitness: 0,
                strength: 1,
                pace: 1,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Carrilero (Unterstützen)",
        id: "r35",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 2,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 0,
                composure: 1,
                offTheBall: 1,
                positioning: 2,
                teamwork: 2,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 2,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Defensiver Flügelspieler (Verteidigen)",
        id: "r36",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 1,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 1,
                freeKickTaking: 0,
                heading: 0,
                passing: 0,
                tackling: 1,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 1,
                anticipation: 2,
                workRate: 2,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 0,
                composure: 0,
                offTheBall: 2,
                positioning: 2,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 1,
                stamina: 2,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Defensiver Flügelspieler (Unterstützen)",
        id: "r37",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 1,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 2,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 1,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 1,
                anticipation: 1,
                workRate: 2,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 1,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 1,
                stamina: 2,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Enganche (Unterstützen)",
        id: "r38",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 0,
                decisions: 2,
                flair: 1,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 2,
                offTheBall: 1,
                positioning: 0,
                teamwork: 0,
                vision: 2,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 1,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Flügelspieler (Unterstützen)",
        id: "r39",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 2,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 0,
                workRate: 1,
                decisions: 0,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 0,
                offTheBall: 2,
                positioning: 0,
                teamwork: 0,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 1,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 2,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Flügelspieler (Angreifen)",
        id: "r40",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 2,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 0,
                workRate: 1,
                decisions: 0,
                flair: 1,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 0,
                offTheBall: 2,
                positioning: 0,
                teamwork: 0,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 0,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 2,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Inverser Außenstürmer (Unterstützen)",
        id: "r41",
        attributes: {
            technical: {
                finishing: 1,
                firstTouch: 2,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 1,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 0,
                decisions: 0,
                flair: 1,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 0,
                teamwork: 0,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 0,
                balance: 2,
                agility: 2,
                naturalFitness: 0,
                strength: 0,
                pace: 1,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Inverser Außenstürmer (Angreifen)",
        id: "r42",
        attributes: {
            technical: {
                finishing: 2,
                firstTouch: 2,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 1,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 0,
                decisions: 0,
                flair: 1,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 0,
                teamwork: 0,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 0,
                balance: 2,
                agility: 2,
                naturalFitness: 0,
                strength: 0,
                pace: 1,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Inverser Flügelspieler (Unterstützen)",
        id: "r43",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 1,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 1,
            },
            mental: {
                aggression: 0,
                anticipation: 0,
                workRate: 1,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 0,
                teamwork: 0,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 1,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 1,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Inverser Flügelspieler (Angreifen)",
        id: "r44",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 1,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 1,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 0,
                decisions: 1,
                flair: 1,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 0,
                teamwork: 0,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 0,
                balance: 0,
                agility: 2,
                naturalFitness: 0,
                strength: 0,
                pace: 1,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Mezzala (Unterstützen)",
        id: "r45",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 0,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 1,
                technique: 2,
                longThrows: 0,
                longShots: 1,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 2,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 0,
                teamwork: 0,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 1,
                balance: 1,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Mezzala (Angreifen)",
        id: "r46",
        attributes: {
            technical: {
                finishing: 1,
                firstTouch: 1,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 1,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 2,
                decisions: 2,
                flair: 1,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 0,
                teamwork: 0,
                vision: 2,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 1,
                balance: 1,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Offensiver Mittelfeldspieler (Unterstützen)",
        id: "r47",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 0,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 2,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 0,
                decisions: 2,
                flair: 2,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 0,
                teamwork: 0,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Offensiver Mittelfeldspieler (Angreifen)",
        id: "r48",
        attributes: {
            technical: {
                finishing: 1,
                firstTouch: 2,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 2,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 0,
                decisions: 2,
                flair: 2,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 0,
                teamwork: 0,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Raumdeuter (Angreifen)",
        id: "r49",
        attributes: {
            technical: {
                finishing: 2,
                firstTouch: 1,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 0,
                tackling: 0,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 1,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 2,
                bravery: 0,
                composure: 2,
                offTheBall: 2,
                positioning: 0,
                teamwork: 0,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 1,
                stamina: 1,
                balance: 2,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Regista (Unterstützen)",
        id: "r50",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 0,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 1,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 0,
                decisions: 2,
                flair: 2,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 2,
                offTheBall: 2,
                positioning: 0,
                teamwork: 2,
                vision: 2,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 1,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Schattenstürmer (Angreifen)",
        id: "r51",
        attributes: {
            technical: {
                finishing: 2,
                firstTouch: 2,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 0,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 1,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 0,
                composure: 2,
                offTheBall: 2,
                positioning: 0,
                teamwork: 0,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 1,
                balance: 1,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 1,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Segundo Volante (Unterstützen)",
        id: "r52",
        attributes: {
            technical: {
                finishing: 1,
                firstTouch: 1,
                marking: 2,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 2,
                technique: 0,
                longThrows: 0,
                longShots: 1,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 2,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 2,
                teamwork: 0,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 1,
                stamina: 2,
                balance: 1,
                agility: 0,
                naturalFitness: 0,
                strength: 1,
                pace: 2,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Segundo Volante (Angreifen)",
        id: "r53",
        attributes: {
            technical: {
                finishing: 2,
                firstTouch: 1,
                marking: 1,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 2,
                technique: 0,
                longThrows: 0,
                longShots: 2,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 2,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 2,
                teamwork: 0,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 1,
                stamina: 2,
                balance: 1,
                agility: 0,
                naturalFitness: 0,
                strength: 1,
                pace: 2,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Tiefer Sechser (Verteidigen)",
        id: "r54",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 0,
                marking: 2,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 1,
                passing: 1,
                tackling: 2,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 1,
                anticipation: 2,
                workRate: 2,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 2,
                bravery: 1,
                composure: 1,
                offTheBall: 0,
                positioning: 2,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 2,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 1,
                pace: 0,
                jumpingReach: 1,
            }
        }
    },
    {
        // label: "Vertikaler Spielmacher (Unterstützen)",
        id: "r55",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 0,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 1,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 2,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 0,
                composure: 2,
                offTheBall: 2,
                positioning: 1,
                teamwork: 2,
                vision: 2,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 2,
                balance: 1,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 1,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Vorgeschobener Spielmacher (Unterstützen)",
        id: "r56",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 0,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 0,
                decisions: 2,
                flair: 1,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 2,
                offTheBall: 2,
                positioning: 0,
                teamwork: 2,
                vision: 2,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Vorgeschobener Spielmacher (Angreifen)",
        id: "r57",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 0,
                decisions: 2,
                flair: 1,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 2,
                offTheBall: 2,
                positioning: 0,
                teamwork: 2,
                vision: 2,
                determination: 0,
            },
            physical: {
                acceleration: 1,
                stamina: 0,
                balance: 0,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Zentraler Mittelfeldspieler (Verteidigen)",
        id: "r58",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 1,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 1,
                anticipation: 1,
                workRate: 1,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 2,
                bravery: 0,
                composure: 1,
                offTheBall: 0,
                positioning: 2,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 1,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Zentraler Mittelfeldspieler (Unterstützen)",
        id: "r59",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 2,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 1,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 0,
                composure: 1,
                offTheBall: 1,
                positioning: 0,
                teamwork: 2,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 1,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Zentraler Mittelfeldspieler (Angreifen)",
        id: "r60",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 1,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 1,
                technique: 1,
                longThrows: 0,
                longShots: 1,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 1,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 1,
                offTheBall: 2,
                positioning: 0,
                teamwork: 1,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 1,
                stamina: 1,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Zurückgezogener Spielmacher (Verteidigen)",
        id: "r61",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 1,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 2,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 2,
                offTheBall: 0,
                positioning: 1,
                teamwork: 2,
                vision: 2,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 1,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Zurückgezogener Spielmacher (Unterstützen)",
        id: "r62",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 2,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 1,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 2,
                offTheBall: 1,
                positioning: 0,
                teamwork: 2,
                vision: 2,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 1,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },

    // Striker
    {
        // label: "Falsche Neun (Unterstützen)",
        id: "r63",
        attributes: {
            technical: {
                finishing: 1,
                firstTouch: 2,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 0,
                decisions: 2,
                flair: 1,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 2,
                offTheBall: 2,
                positioning: 0,
                teamwork: 1,
                vision: 2,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 0,
                balance: 1,
                agility: 2,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Hängende Spitze (Unterstützen)",
        id: "r64",
        attributes: {
            technical: {
                finishing: 1,
                firstTouch: 2,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 0,
                decisions: 2,
                flair: 1,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 2,
                offTheBall: 2,
                positioning: 0,
                teamwork: 2,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 1,
                agility: 0,
                naturalFitness: 0,
                strength: 1,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Hängende Spitze (Angreifen)",
        id: "r65",
        attributes: {
            technical: {
                finishing: 1,
                firstTouch: 2,
                marking: 0,
                dribbling: 1,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 0,
                decisions: 2,
                flair: 1,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 2,
                offTheBall: 2,
                positioning: 0,
                teamwork: 2,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 1,
                agility: 0,
                naturalFitness: 0,
                strength: 1,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Knipser (Angreifen)",
        id: "r66",
        attributes: {
            technical: {
                finishing: 2,
                firstTouch: 1,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 1,
                passing: 0,
                tackling: 0,
                technique: 1,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 0,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 2,
                offTheBall: 2,
                positioning: 0,
                teamwork: 0,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 1,
                stamina: 0,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Kompletter Stürmer (Unterstützen)",
        id: "r67",
        attributes: {
            technical: {
                finishing: 1,
                firstTouch: 2,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 2,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 2,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 1,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 2,
                offTheBall: 2,
                positioning: 0,
                teamwork: 1,
                vision: 2,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 1,
                balance: 1,
                agility: 2,
                naturalFitness: 0,
                strength: 2,
                pace: 1,
                jumpingReach: 1,
            }
        }
    },
    {
        // label: "Kompletter Stürmer (Angreifen)",
        id: "r68",
        attributes: {
            technical: {
                finishing: 2,
                firstTouch: 2,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 2,
                passing: 1,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 1,
            },
            mental: {
                aggression: 0,
                anticipation: 2,
                workRate: 1,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 2,
                offTheBall: 2,
                positioning: 0,
                teamwork: 1,
                vision: 1,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 1,
                balance: 1,
                agility: 2,
                naturalFitness: 0,
                strength: 2,
                pace: 1,
                jumpingReach: 1,
            }
        }
    },
    {
        // label: "Pressender Stürmer (Verteidigen)",
        id: "r69",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 0,
                tackling: 0,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 2,
                anticipation: 2,
                workRate: 2,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 2,
                composure: 1,
                offTheBall: 0,
                positioning: 0,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 2,
                balance: 1,
                agility: 1,
                naturalFitness: 0,
                strength: 1,
                pace: 2,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Pressender Stürmer (Unterstützen)",
        id: "r70",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 0,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 2,
                anticipation: 2,
                workRate: 2,
                decisions: 2,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 2,
                composure: 1,
                offTheBall: 1,
                positioning: 0,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 2,
                balance: 1,
                agility: 1,
                naturalFitness: 0,
                strength: 1,
                pace: 2,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Pressender Stürmer (Angreifen)",
        id: "r71",
        attributes: {
            technical: {
                finishing: 1,
                firstTouch: 1,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 0,
                tackling: 0,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 2,
                anticipation: 2,
                workRate: 2,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 1,
                bravery: 2,
                composure: 1,
                offTheBall: 2,
                positioning: 0,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 2,
                balance: 1,
                agility: 1,
                naturalFitness: 0,
                strength: 1,
                pace: 2,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Stoßstürmer (Angreifen)",
        id: "r72",
        attributes: {
            technical: {
                finishing: 2,
                firstTouch: 2,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 1,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 2,
                offTheBall: 2,
                positioning: 0,
                teamwork: 0,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 1,
                balance: 1,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 1,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Trequartista (Angreifen)",
        id: "r73",
        attributes: {
            technical: {
                finishing: 1,
                firstTouch: 2,
                marking: 0,
                dribbling: 2,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 2,
                tackling: 0,
                technique: 2,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 0,
                anticipation: 1,
                workRate: 0,
                decisions: 2,
                flair: 2,
                leadership: 0,
                concentration: 0,
                bravery: 0,
                composure: 2,
                offTheBall: 2,
                positioning: 0,
                teamwork: 0,
                vision: 2,
                determination: 0,
            },
            physical: {
                acceleration: 2,
                stamina: 0,
                balance: 1,
                agility: 1,
                naturalFitness: 0,
                strength: 0,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Zielspieler (Unterstützen)",
        id: "r74",
        attributes: {
            technical: {
                finishing: 1,
                firstTouch: 1,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 2,
                passing: 0,
                tackling: 0,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 1,
                anticipation: 1,
                workRate: 0,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 2,
                composure: 1,
                offTheBall: 1,
                positioning: 0,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 2,
                agility: 0,
                naturalFitness: 0,
                strength: 2,
                pace: 0,
                jumpingReach: 2,
            }
        }
    },
    {
        // label: "Zielspieler (Angreifen)",
        id: "r75",
        attributes: {
            technical: {
                finishing: 2,
                firstTouch: 1,
                marking: 0,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 2,
                passing: 0,
                tackling: 0,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 1,
                anticipation: 1,
                workRate: 0,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 0,
                bravery: 2,
                composure: 2,
                offTheBall: 2,
                positioning: 0,
                teamwork: 1,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 0,
                balance: 2,
                agility: 0,
                naturalFitness: 0,
                strength: 2,
                pace: 0,
                jumpingReach: 2,
            }
        }
    },
    {
        // label: "Defensiver Mittelfeldspieler (Verteidigen)",
        id: "r76",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 0,
                marking: 1,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 2,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 1,
                anticipation: 2,
                workRate: 2,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 2,
                bravery: 0,
                composure: 1,
                offTheBall: 0,
                positioning: 2,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 2,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 1,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
    {
        // label: "Defensiver Mittelfeldspieler (Unterstützen)",
        id: "r77",
        attributes: {
            technical: {
                finishing: 0,
                firstTouch: 1,
                marking: 1,
                dribbling: 0,
                corners: 0,
                penaltyTaking: 0,
                crossing: 0,
                freeKickTaking: 0,
                heading: 0,
                passing: 1,
                tackling: 2,
                technique: 0,
                longThrows: 0,
                longShots: 0,
            },
            mental: {
                aggression: 1,
                anticipation: 2,
                workRate: 2,
                decisions: 1,
                flair: 0,
                leadership: 0,
                concentration: 2,
                bravery: 0,
                composure: 1,
                offTheBall: 0,
                positioning: 2,
                teamwork: 2,
                vision: 0,
                determination: 0,
            },
            physical: {
                acceleration: 0,
                stamina: 2,
                balance: 0,
                agility: 0,
                naturalFitness: 0,
                strength: 1,
                pace: 0,
                jumpingReach: 0,
            }
        }
    },
];

export default roles;